import { useTranslation } from "react-i18next"

/**
 * OKS-52 — One-line read-only summary above the three cards
 * (UX Spec §2.4): "Currently: {N} ranks · base {X} XP/completion".
 * Helps the admin orient before scrolling.
 */
export function ProgressionSummaryStrip({
  rankCount,
  baseXp,
}: {
  rankCount: number
  baseXp: number
}) {
  const { t } = useTranslation()

  return (
    <p
      data-testid="brand-settings-progression-summary"
      className="text-muted-foreground text-sm"
    >
      {t("settings.brand.progression.summary", {
        count: rankCount,
        xp: baseXp,
      })}
    </p>
  )
}
